const customTableStyle = {
    table: {
        width: "100%"
    },
    thead: {
        fontSize: "22px",
    },
    th: {
        padding: "50px 15px 15px",
        textAlign: "left"
    },
    td: {
        padding: "15px",
        fontSize: "20px",
        borderBottom: `1px solid #ddd`,
        textAlign: "left",
        height: "60px"
    },
    overflowX: {
        overflowX: "auto"
    }
}

export default customTableStyle
